<template>
    <div class="container">
        <div class="row" v-if="card">
            <div class="col-12">
                <h1 class="page-heading text-dark">
                    {{ card?.name }}
                    <span v-if="card.amount > 1" class="ml-2 badge rounded-pill bg-info" v-text="card.amount"></span>
                </h1>
            </div>

            <div id="card-detail-view row">
                <div class="col-lg-6 col-md-12 p-0">
                    <img :src="getCardImageUrl(card)" class="card-image mb-3"/>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div v-if="card.set" style="height: 5em;">
                        <img class="float-end set-logo mb-3" :src="card.set.images?.logo"/>
                        <strong>Set: </strong> {{ card.set.name }} <img v-if="card.set.id !== 'base1'" class="set-icon" :src="card.set.images.symbol"/><br/>
                        <strong>Series: </strong>{{ card.set.series }}
                    </div>
                    <p v-if="card.flavorText">{{ card.flavorText }}</p>
                    <span v-if="card.rarity">
                        <strong>Rarity:</strong> {{ card.rarity }}<br/>
                    </span>
                    <span v-if="card.types">
                        <strong>Type: </strong> <img v-for="type in card.types" :src="'/assets/dipocaco/type-icons/'+type+'.png'" alt=""><br/>
                    </span>
                    <div class="row p-0" v-if="card.weaknesses || card.resistances">
                        <span v-if="card.weaknesses" class="col-6 p-0">
                            <strong>Weakness:</strong>
                            <span v-for="weakness in card.weaknesses">
                                <img :src="'/assets/dipocaco/type-icons/'+weakness.type+'.png'" alt=""> {{ weakness.value }}
                            </span>
                            <br/>
                        </span>

                        <span v-if="card.resistances" class="col-6 p-0">
                            <strong>Resistance:</strong>
                            <span v-for="resistance in card.resistances">
                                <img :src="'/assets/dipocaco/type-icons/'+resistance.type+'.png'" alt=""> {{ resistance.value }}
                            </span>
                            <br/>
                        </span>
                    </div>

                    <a v-if="card.cardmarket" :href="card.cardmarket.url" class="btn w-100 mt-1 mb-2 text-center text-white" target="_blank" style="background-color: #012169">
                        Show on <img src="/assets/dipocaco/cardmarket.png" style="height: 1.1em;">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import CardService from "../../CardService.js";

export default {
    name: "CardDetailView",
    data() {
        return {
            card: null,
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        axios.get('/api/cards/' + this.$route.params.card_id).then((response) => {
            this.card = response.data;
        });
    },
    methods: {
        getCardImageUrl(card) {
            return CardService.getCardImageUrl(card);
        },
    }
}
</script>

<style lang="scss" scoped>
.card-image {
    width: 100%;
    border-radius: 10px;
}

.currency-icon {
    max-height: 2em;
}

.set-logo {
    max-height: 3em;
}

.set-icon {
    max-height: 1.8em;
}
</style>
